import config from '../config'
import { debug } from '../utilities/logger'
import { injectScript } from '../utilities/window'

(() => {
  if (!config['usersnap-active']) {
    return debug(`[vendors][UserSnap] Deactivated cause not heroku environment`)
  }
  if (window.onUsersnapCXLoad) {
    return
  }
  window.onUsersnapCXLoad = function (api) {
    api.init()
  }
  injectScript({ url: `https://widget.usersnap.com/load/${config['usersnap-key']}?onload=onUsersnapCXLoad`, isAsync: true })
})()



// WEBPACK FOOTER //
// ./src/vendors/UserSnap.js